import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import Verification from '../../components/Verification';
import useErrors from '../../hooks/useErrors';
import { useStore } from '../../stores';
import EmailsService from '../../services/EmailsService';

export default function V1() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { setVerification, userData } = useStore(useShallow((state) => ({
    setVerification: state.setVerification,
    userData: state.userData,
  })));

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  const { email } = userData || {};

  function handleCode(e) {
    setCode(e.target.value);

    removeError('code');
  }

  async function onSubmit() {
    try {
      setLoading(true);

      if (!code) {
        setError({ field: 'code', message: 'O código é obrigátorio' });
        throw new Error('O código está vazio');
      }

      await EmailsService.verifEmail(email, code);

      setVerification(2);
      navigate('/modelregister/v2');
    } catch (error) {
      const message = error.response.data.error;

      console.log(error);

      setError({ field: 'code', message });
    } finally {
      setLoading(false);
    }
  }

  const isFormValid = Boolean(code) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Verification v={1} />

        <Title
          title="Email de verificação enviado"
          subtitle="Faça a validação do seu email"
        />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Continuar"
          next
          isLoading={loading}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('code')}>
            <label>Código*</label>
            <input
              type="number"
              placeholder="Digite o código de verificação"
              value={code}
              onChange={handleCode}
            />
          </GroupInput>
        </FormAuth>
      </Center>
    </FormContainer>
  );
}
